import React, { useState } from 'react';
import { Flex } from '@components/Flex';
import { NodesContainer, StyledButton, StyledGradient, StyledSection, StyledTitle } from './SEOContentSection.styles';
import { Text } from '@components/typography';
import { JoykitColor } from '@components/themes';

interface NodeType
  extends Readonly<{
    title: string;
    content: string[];
  }> {}

interface SEOContentSectionProps {
  id: string;
  ctaLabel: string;
  nodes: ReadonlyArray<NodeType>;
  backgroundColor?: JoykitColor;
}

export const SEOContentSection: React.FC<SEOContentSectionProps> = ({ id, ctaLabel, nodes, backgroundColor }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Flex justifyContent="center" backgroundColor={backgroundColor}>
      <StyledSection as="section" id={id}>
        <NodesContainer style={{ maxHeight: isExpanded ? 'none' : '300px', overflow: 'hidden' }}>
          {nodes.map((node) => (
            <React.Fragment key={node.title}>
              <StyledTitle variant="featureCopy17" tagName="h4" color="mono1">
                {node.title}
              </StyledTitle>
              {node.content.map((content) => (
                <Text variant="featureCopy17" tagName="p" key={content} color="mono1">
                  {content}
                </Text>
              ))}
            </React.Fragment>
          ))}
          {!isExpanded && <StyledGradient gradientColor={backgroundColor} />}
        </NodesContainer>
        {!isExpanded && (
          <StyledButton id="read-more" onClick={() => setIsExpanded(!isExpanded)}>
            <Text variant="featureCopy17" tagName="span" color="mono1">
              {ctaLabel}
            </Text>
          </StyledButton>
        )}
      </StyledSection>
    </Flex>
  );
};
